module.exports = __webpack_public_path__ + "assets/domain.cf60b2b7.svg";